import styled from "styled-components";
import { pagePadding } from "_/style/layout";

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  width: 100%;
  color: ${(p) => p.theme.text.default};
  ${pagePadding};
`;

export const PageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
`;

export const PageTitle = styled.h1`
  margin: 0;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const SectionTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
`;

// Re-export shared styled components from queue to avoid duplication
export { SubmittedCell, SubmittedAgo } from "_/components/queue/styled";
